import { createSlice } from '@reduxjs/toolkit';

/**
 * Stores the latest driver profile photo URL (e.g. after saving from Digital ID Card).
 * Profile Setting page uses this to show the updated image.
 */
const initialState = {
	latestPhotoUrl: null,
};

const driverProfilePhotoSlice = createSlice({
	name: 'driverProfilePhoto',
	initialState,
	reducers: {
		setLatestDriverPhotoUrl: (state, action) => {
			state.latestPhotoUrl = action.payload ?? null;
		},
		clearLatestDriverPhotoUrl: (state) => {
			state.latestPhotoUrl = null;
		},
	},
});

export const { setLatestDriverPhotoUrl, clearLatestDriverPhotoUrl } = driverProfilePhotoSlice.actions;
export default driverProfilePhotoSlice.reducer;
